function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";

var SvgStarHalfFade = function SvgStarHalfFade(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? 'Half Faded Star' : _ref$title,
      stroke = _ref.stroke,
      dir = _ref.dir,
      props = _objectWithoutProperties(_ref, ["title", "stroke", "dir"]);

  return React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 46 44"
  }, dir === 'rtl' ? {
    transform: 'scale(-1, 1)'
  } : {}), React.createElement("g", null, React.createElement("path", {
    d: "M22.825 36L8.72 43.416l2.694-15.708L0 16.584l15.772-2.292L22.825 0z",
    strokeWidth: 3,
    stroke: stroke
  }), React.createElement("polygon", {
    fill: "#FFF",
    strokeWidth: 3,
    stroke: stroke,
    points: "22.8253564 36 22.8253564 2.34479103e-13 29.8787794 14.2917961 45.6507128 16.5835921 34.2380346 27.7082039 36.9322024 43.4164079"
  })));
};

SvgStarHalfFade = pure(SvgStarHalfFade);
SvgStarHalfFade.displayName = 'SvgStarHalfFade';
export default SvgStarHalfFade;